import React, { useEffect, useState } from 'react';
import styles from './BrandsInformation.module.scss';
import { Button, Col, Container, Row } from 'reactstrap';
import ManageTable from '../../../../views/Manage/ManageTable';

const BrandsInformation = ({ setIsBrandDetail, setSelectedRow, columnsData, setColumnsData }) => {
    let totalBrands = "05";
    let pendingApprovals = "02";
    let rejectedBrands = "01";

    const data = [
        {
            id: 1,
            brandName: 'ABC brand',
            category: 'Electronics',
            relation: 'Owner',
            dateApplied: '19/06/2024',
            expirationDate: '-',
            status: 'Pending',
        },
        {
            id: 2,
            brandName: 'ABC brand',
            category: 'Electronics',
            relation: 'Reseller',
            dateApplied: '19/06/2024',
            expirationDate: '-',
            status: 'Rejected',
        },
        {
            id: 3,
            brandName: 'ABC brand',
            category: 'Electronics',
            relation: 'Owner',
            dateApplied: '19/06/2024',
            expirationDate: '-',
            status: 'Approved',
        },
    ];

    const columns = [
        {
            name: 'Brand Name',
            selector: (row) => row.brandName,
            sortable: true,
            minWidth: "140px",
        },
        {
            name: 'Category',
            selector: (row) => row.category,
        },
        {
            name: 'Relation',
            selector: (row) => row.relation,
            sortable: true,
        },
        {
            name: 'Date Applied',
            selector: (row) => row.dateApplied,
            sortable: true,
            minWidth: "140px",
        },
        {
            name: 'Expiration date',
            selector: (row) => row.expirationDate,
            sortable: true,
            minWidth: "140px",
        },
        {
            name: 'Status',
            selector: (row) => row.status,
        },
        {
            name: 'Action',
            cell: (row) => (
                <div>
                    <Button
                        type="button"
                        color="link"
                        className={styles.brandActionButton}
                        onClick={() => handleActionClick(row)}
                    >
                        {row.status === "Rejected" ? "Update/Re-apply" : "Update"}
                    </Button>
                </div>
            ),
            minWidth: "150px",
        },
    ];

    useEffect(() => {
        setColumnsData(columns);
    }, [setColumnsData]);

    const handleActionClick = (row) => {
        setSelectedRow(row);
        setIsBrandDetail(true);
    };

    return (
        <div className={styles.brandsInfoContainer}>
            <h4 className={styles.sectionHeading}>Brands Information</h4>

            <Row className={styles.brandStats}>
                <Col lg={6} xxl={3} className={styles.statsBox}>
                    <div className={styles.statsContent}>Total Brands: <span>{totalBrands}</span></div>
                    <div className={styles.statsContent}>Pending Approvals: <span>{pendingApprovals}</span></div>
                    <div className={styles.statsContent}>Rejected Brands: <span>{rejectedBrands}</span></div>
                </Col>
            </Row>

            <Container fluid className={styles.tableContainer}>
                <ManageTable
                    name={'Active Products'}
                    columns={columnsData}
                    tableData={data}
                />
            </Container>
        </div>
    )
}

export default BrandsInformation;